<template>
  <div class="container-audit">
    <h4 class="audit-title">La sección Consulta, te permite cargar la información de tu facturación y generar un reporte que te ayude a revisar el detalle de los montos facturados.</h4>

    <section class="audit-card">
      <div v-for="(step, index) in steps" :key="index" class="step-container">
        <h4 class="step-number">Paso {{ index + 1 }} <span class="step-title">{{ step.title }}</span></h4>
        <p class="step-description">{{ step.description }}</p>
        <b-form-group
            v-if="step.id === 1"
            label-for="carriersList"
            label="Courier"
            class="col-lg-5 fieldSelect background_4_blue"
          >
            <v-select
              id="carriersList"
              class="select-couriers"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              v-model="currentCourier"
              :options="optionCouriers"
              placeholder="Seleccione el courier"
              label="text"
              required
              v-if="!loadingAllCountries"
            >
              <template #no-options="{ }" v-if="m_isAdmin()">
                No hay couriers disponibles, seleccione una compañia
              </template>
            </v-select>
            <div class="d-flex" v-if="loadingAllCountries">
              <b-skeleton height="32px" width="100%"/>
            </div>

        </b-form-group>
        <div class="file-upload-container col-lg-5" v-else>
          <label class="file-label label">
            Archivo reporte <span class="required">*</span>
            <span class="download-link" @click="downloadFormat">(Descargar Formato)</span>
          </label>
          <div
            id="fileInputContainer" :class="{ disabled: !currentCourier }"
            class="file-input-container" @click="handleClickOnFileInput">
            <div v-if="selectedFile" class="file-input-overlay selected">
              <span class="file-name">{{ selectedFileName }}</span>
              <span class="file-size">({{ formattedFileSize }})</span>
              <feather-icon
                icon="XIcon"
                size="18"
                class="clear-icon"
                @click.stop="clearFileSelection" />
            </div>

            <div v-else class="file-input-overlay">
              <feather-icon icon="UploadCloudIcon" size="20" class="file-icon"/>
              <span class="file-text">Seleccionar archivo</span>
            </div>

            <input
              ref="fileInput"
              type="file"
              accept=".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
              style="display: none;" @change="handleFileChange"
            >

            <div class="progress-bar" :style="{width: progress + '%'}"></div>
            </div>
        </div>
        <div v-if="step.id === 2 && validationStatus" class="validation-message-wrapper">
          <div
            class="validation-message"
            :class="{
              'message-ok': validationStatus === 'ok',
              'message-error': validationStatus === 'error'
            }"
          >
            <feather-icon
              :icon="validationStatus === 'ok' ? 'CheckCircleIcon' : 'XCircleIcon'"
              size="16"
              :class="validationStatus === 'ok' ? 'icon-ok' : 'icon-error'"
            />
            {{ validationMessage }}
            <span
              v-if="validationStatus === 'error' && errorsConnectDetail.length > 0"
              class="link-detail ml-1"
              @click="showErrorModal"
            >
              Ver detalle
            </span>
          </div>
        </div>

        <article v-show="step.note" class="step-note">
          <p>
    <span>Nota:</span>
    <template v-if="step.id === 1">
      Para generar el reporte, es necesario que cuentes con tarifas cargadas para el courier que deseas consultar.
      Puedes cargar, revisar y actualizar tarifas en la pestaña
      <button class="link-tarifas" @click="goToTabTarifas">Tarifas</button>.
    </template>
    <template v-else>
      {{ step.note }}
    </template>
  </p>
        </article>

      </div>
<b-button
  variant="warning"
  class="audit-button"
  @click="validateAndSubmit"
  :disabled="loading || isValidating || !fileValidated"
>
  <span v-if="!loading && !isValidating">Auditar</span>
  <span v-else-if="isValidating">Validando...</span>
  <b-spinner v-else small />
</b-button>
<modal-error-connect  :errorsList="errorsConnectDetail" />
    </section>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'
import BaseServices from '@/store/services/index'
import ModalErrorConnect from './ModalErrorConnect.vue'

export default {
  components: {
    vSelect,
    ModalErrorConnect
  },
  props: {
    goToTab: {
      type: Function,
      default() {}
    }
  },
  data() {
    return {
      baseService: new BaseServices(this),
      form: {},
      loading: false,
      showResults: false,
      isValidating: false,
      fileValidated: false,
      validationStatus: null,
      validationMessage: '',
      errorsConnectDetail: [],
      tabIndex: 0,
      dataPrice: [],
      dataCoverage: [],
      formFile: {},
      fileInput: null,
      selectedFile: null,
      selectedFileName: null,
      currentCourier: null,
      progress: 0,
      showCircle: false,
      optionCouriers: [
      ],
      steps: [
        {
          id: 1,
          title:  'Selecciona el courier que quieras auditar.',
          description: 'Selecciona el courier para generar el reporte. Solo aparecerán en el listado los couriers con tarifas de servicios previamente cargadas.',
          note: 'Para generar el reporte, es necesario que cuentes con tarifas cargadas para el courier que deseas consultar. Puedes cargar, revisar y actualizar tarifas en la pestaña Tarifas.'
        },
        {
          id: 2,
          title: 'Carga el detalle de facturación para generar el reporte.',
          description: 'Puedes importar el archivo desde tu dispositivo haciendo clic en “Seleccionar archivo” o descargar la plantilla de ejemplo desde el enlace “Descargar formato”.',
          note: null
        }
      ],
      loadingAllCountries: false
    }
  },
  methods: {
    async handleFileChange(event) {
      const file = event.target.files[0]
      if (file) {
        const allowedTypes = [
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ]
        if (allowedTypes.includes(file.type) || file.name.endsWith('.xlsx')) {
          this.selectedFile = file
          this.selectedFileName = file.name
          this.progress = 0
          this.showCircle = false
          await this.validateFileBeforeAudit()
        } else {
          this.$alert('Por favor, selecciona un archivo Excel válido (.xlsx).')
          this.clearFileSelection()
        }
      } else {
        this.clearFileSelection()
      }
    },
    handleClickOnFileInput() {
      if (this.currentCourier) {
        this.triggerFileInputClick()
      } else {
        this.$newError('Por favor, selecciona un courier primero.')
      }
    },
    showErrorModal() {
      this.$bvModal.show('modal-error-connect')
    },
    downloadFormat() {
      // Usa tu sistema de descarga de archivos (ej. window.open o axios)
      window.open('https://storage.googleapis.com/miami-billing-public-frontend-templates-stage/excel-sample-delivery-connect/formato-entrada-cl-cencosud-skn-b7dfcf1c.xlsx', '_blank')
    },
    triggerFileInputClick() {
      this.$refs.fileInput[0].click()
    },
    async validateAndSubmit() {
      if (!this.isFormValid) {
        this.$alert('Por favor, selecciona un courier y un archivo.')
        return
      }

      this.loading = true
      this.progress = 0
      const data = {
        file: this.selectedFile,
        carrierCode: this.currentCourier.value
      }

      const params = {
        company_id: 1162
      }
      this.baseService.callUploadFileCustomParams('uploadExcelConnect', data, params)
        .then(response => {
          this.progress = 100
          this.showCircle = true
          // Usa tu sistema de notificaciones (ej. this.$success o this.$bvToast)
          this.$newSuccess('¡Generando archivo de Auditoría Connect!', 'Esta acción puede tardar unos minutos. Le notificaremos al correo de su usuario Envíame al finalizar.')
          this.clearFileSelection()
        }).catch((error) => {
          this.$newError(error?.errors[0]?.title, error?.errors[0]?.detail)
        }).finally(() => {
          this.loading = false
        })
    },
    clearFileSelection(resetMessage = true) {
      this.selectedFile = null
      this.selectedFileName = null
      this.progress = 0
      this.showCircle = false

      if (resetMessage) {
        this.validationStatus = null
        this.validationMessage = ''
      }

      if (this.$refs.fileInput[0]) {
        this.$refs.fileInput[0].value = null
      }
    },
    formatBytes(bytes, decimals = 2) {
      if (!+bytes) return '0 Bytes'
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    goToTabTarifas() {
      this.goToTab(1)
    },
    async validateFileBeforeAudit() {
      this.isValidating = true
      this.fileValidated = false
      const data = {
        file: this.selectedFile,
        carrierCode: this.currentCourier?.value,
        validateOnly: 1
      }
      const params = {
        company_id: 1162
      }
      try {
        await this.baseService.callUploadFileCustomParams('uploadExcelConnect', data, params)
        this.fileValidated = true
        this.validationStatus = 'ok'
        this.validationMessage = '¡Archivo ok!'
      } catch (error) {
        this.validationStatus = 'error'
        this.validationMessage = `¡Error en validación! ${error?.errors[0]?.title || 'Falló totalmente el archivo'}`
        this.errorsConnectDetail = Array.isArray(error?.errors[0]?.detail) ? error?.errors[0]?.detail?.map(err => ({title: error?.errors[0]?.title, detail: err })) : []
        this.clearFileSelection(false)
      } finally {
        this.isValidating = false
      }
    }
  },
  computed: {
    ...mapGetters({
      connectAviableConnect: 'getCompaniesConnect',
      generalLoading: 'getLoading'
    }),
    // Propiedad computada para habilitar/deshabilitar el botón de auditar
    isFormValid() {
      return this.currentCourier !== null && this.selectedFile !== null
    },
    formattedFileSize() {
      if (this.selectedFile) {
        return this.formatBytes(this.selectedFile.size)
      }
      return ''
    }
  },
  watch: {
    connectAviableConnect() {
      this.optionCouriers = this.connectAviableConnect.carriersList.map(courier => ({
        value: courier.code,
        text: courier.name
      }))
    },
    generalLoading: {
      handler() {
        this.loadingAllCountries = !!this.generalLoading.getCompaniesConnect
      },
      deep: true
    }
  }
}
</script>

<style scoped lang='scss'>
.container-audit {
  margin: auto;
  padding: 1rem;
}
.audit-title {
  font-size: 1rem;
  font-weight: 400;
  color: #6E6B7B;
  font-family: 'Montserrat';
  margin-bottom: 20px;
}
.audit-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0.938rem;
}
.step-container {
  width: 100%;
  padding: 20px;
  border-radius: 8px;
  background: #0443890D;
  border: 1px solid #ddd;
  margin-bottom: 10px;
}
.step-number {
  font-size: 2rem;
  font-weight: 400;
  color: #044389;
}

.validation-message-wrapper {
  margin: -20px; // anula padding lateral del step-container
  margin-top: 2px;
}

.step-title {
  font-size: 1rem;
  font-weight: 400;
  margin-top: 5px;
}
.step-description {
  font-size: 14px;
  color: #6c757d;
}
.select-couriers {
  background-color: #FFFFFF;
  border: 1px solid #D4D9DF;
  border-radius: 10px;
}
.step-note {
  margin-top: 1rem;
  padding-top: 0.5rem;
  border-top: #0443890D 2px solid;
  color: #6E6B7B;
  font-weight: 400;

  span {
    font-weight: bold;
  }
}

.file-input-container.disabled {
  cursor: not-allowed;
  opacity: 0.6;
  pointer-events: auto;
}

.audit-button {
  position: absolute;
  bottom: 5px;
  right: 20px;
  background-color: #f0ad4e;
  border: none;
  color: white;
  font-weight: bold;
  padding: 10px 20px;
  border-radius: 5px;
  z-index: 1000;
}
.audit-button:disabled {
  background-color: #f7c984;
}
.results-container {
  margin-top: 20px;
}

.custom-file-input-group {
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
}

.feather-icon {
  width: 18px;
  height: 18px;
  color: #6c757d;
  margin-top: 2px;
}

.custom-file-style {
  background-color: #ffffff;
  border: none;
  color: #6c757d;
}

    .file-upload-container {
      margin: 20px 0;
    }
    .file-label {
      color: #666;
      margin-bottom: 5px;
      display: block;
    }
    .download-link {
      color: #0066cc;
      text-decoration: underline;
      margin-left: 5px;
      cursor: pointer;
    }
    .file-input-container {
      border: 1px solid #ccc;
      border-radius: 4px;
      padding: 10px;
      position: relative;
      background-color: #ffffff;
      display: flex;
      align-items: center;
    }
    .file-input-overlay {
      position: relative;
      display: flex;
      align-items: center;
      width: 100%;
    }
    .file-icon {
      color: #999;
      margin-right: 10px;
    }
    .file-text {
      color: #999;
      flex-grow: 1;
    }
    .progress-bar {
      height: 4px;
      position: absolute;
      bottom: 0;
      left: 0;
      background-color: #8bc34a;
      transition: width 0.3s;
    }
    .upload-circle {
      width: 60px;
      height: 60px;
      background-color: rgba(139, 195, 74, 0.2);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 10px;
      z-index: 2;
    }


.link-tarifas {
  color: #004389;
  cursor: pointer;
  padding: 0;
  background: none;
  border: none;
  font: inherit;
  font-weight: 500;
}


.file-input-container {
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px;
  position: relative;
  background-color: #ffffff;
  display: flex;
  align-items: center;
  min-height: 40px; // Altura mínima consistente
  cursor: pointer; // Indica que es clickeable
  overflow: hidden; // Para la barra de progreso
}

.file-input-overlay {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
  &.selected {
    justify-content: space-between;
    gap: 5px; 
  }
}

// Estado NO seleccionado
.file-icon {
  color: #999; // Icono gris
  flex-shrink: 0;
}
.file-text {
  color: #999; // Texto placeholder gris
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// Estado SELECCIONADO
.file-name {
  color: #0056b3;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  flex-grow: 1;
  min-width: 0;
}

.file-size {
  color: #6c757d;
  font-size: 0.9em;
  white-space: nowrap;
  flex-shrink: 0;
}

.clear-icon {
  color: #6c757d;
  cursor: pointer;
  flex-shrink: 0;
  margin-left: auto;

  &:hover {
    color: #333;
  }
}

// Barra de progreso
.progress-bar {
  height: 4px;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #8bc34a;
  transition: width 0.3s ease;
  z-index: 1
}


.validation-message {
  width: 100%;
  background-color: #F9F9FD;
  border-radius: 8px;
  padding: 12px 16px;
  padding-left: 29px;
  margin-top: 12px;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  border-left: 4px solid transparent;

  &.message-ok {
    color: #4CAF50;
    border-left-color: #4CAF50;
  }

  &.message-error {
    color: #D9534F;
    border-left-color: #D9534F;
  }

  .icon-ok, .icon-error {
    margin-right: 8px;
    flex-shrink: 0;
  }

  .link-detail {
    color: #0056b3;
    text-decoration: underline;
    cursor: pointer;
    margin-left: auto;
  }
}

</style>
